
import salutations from '~/static/salutations.json'

export default {
  props: {
    termsText: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      salutations,
      isLoading: false,
      showSuccessMessage: false,
      form: {
        salutation: '',
        company: '',
        first_name: '',
        last_name: '',
        phone: '+41',
        email: '',
        message: '',
        newsletter: false,
        honeypot: '',
      },
    }
  },

  methods: {
    submit() {
      if (this.isLoading) {
        return
      }

      this.isLoading = true

      this.$axios
        .$post('/forms/contact', this.form, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
        .then(() => {
          this.showSuccessMessage = true
        })
        .catch(({ response }) => {
          this.$refs.form.setErrors(response.data.error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
